export const parsers = {
    7: /^(\d)(\d{1,3})?(\d{1,3})?(\d{1,2})?(\d{1,2})?(.+)?/g, // RU
    375: /^(\d{1,3})(\d{1,2})?(\d{1,3})?(\d{1,2})?(\d{1,2})?(.+)?/g, // BY
    380: /^(\d{1,3})(\d{1,2})?(\d{1,3})?(\d{1,2})?(\d{1,2})?(.+)?/g // UA
};

export function format(value) {
    const parser = getParserByRegion(value);

    if (!parser)
        return value;

    return applyMask(value, parser);
}

export function applyMask(digits, parser) {
    return digits.replace(new RegExp(parser), parseMask);
}

export function parseMask(match, code, prefix, line1, line2, line3) {
    let phone = [];

    if (code)
        phone.push(code);

    if (prefix)
        phone.push(` ${prefix}`);

    if (line1)
        phone.push(` ${line1}`);

    if (line2)
        phone.push(`-${line2}`);

    if (line3)
        phone.push(`-${line3}`);

    return phone.join('');
}

export function getParserByRegion(digits) {
    const codes = Object.keys(parsers);

    for (let i in codes) {
        if (digits.startsWith(codes[i])) {
            return parsers[codes[i]];
        }
    }
}

export function filterDigits(string) {
    return string.replace(/[^\d]/gm, '');
}

export const anyExceptDigits = /[^\d]/g;
